import { useState, useEffect } from "react";

export const BackgroundCarousel = ({ images, interval = 7000 }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, interval);

    return () => clearInterval(timer);
  }, [images.length, interval]);

  return (
    <div className="absolute inset-0 z-0">
      {images.map((image, index) => (
        <div
          key={`bg-carousel-${index}`}
          className={`absolute inset-0 transition-all duration-[3000ms] ease-in-out ${
            index === currentIndex ? "opacity-100" : "opacity-0"
          }`}
        >
          <img
            src={image}
            alt={`Luxury bathroom ${index + 1}`}
            className="w-full h-full object-cover"
            style={{
              animation: index === currentIndex ? "slowZoom 7s ease-in-out" : "none"
            }}
          />
          <div className="absolute inset-0 bg-gradient-to-r from-navy-900/95 via-navy-900/85 to-navy-900/70"></div>
        </div>
      ))}
    </div>
  );
};
